import { type Relation, RelationEmpty } from "$lib/data/type/_relation"
import type { Menu } from "$lib/data/type/app/menu"
import type { Module } from "$lib/data/type/app/module"
import type { User } from "$lib/data/type/user"

class AppStore {

  user = $state<User | null>(null)
  modules = $state<Module[]>([])
  menus = $state<Menu[]>([])
  permissions = $state<string[]>([])

  entity = $state<string | undefined>(undefined)
  module = $state<Module | undefined>(undefined)
  menuParent = $state<Menu | undefined>(undefined)
  menuSub = $state<Menu | undefined>(undefined)

  menu = $derived(this.menuSub ?? this.menuParent)
  canStore = $derived(this.menu?.permissions["view"] ?? false)
  canUpdate = $derived(this.menu?.permissions["edit"] ?? false)
  canDestroy = $derived(this.menu?.permissions["delete"] ?? false)
  canApprove = $derived(this.menu?.permissions["apprlv1"] ?? false)
  canImport = $derived(this.menu?.permissions["import"] ?? false)
  canExport = $derived(this.menu?.permissions["export"] ?? false)
  editable = $derived(this.canStore || this.canUpdate)

  warehouses = $state<Relation[]>([])
  warehouse_select = $state<Relation>(RelationEmpty)

  userUpdate = (user: User | null) => {
    this.user = user
  }

  userLogout = () => {
    this.user = null
  }

  modulesUpdate = (modules: Module[]) => {
    this.modules = modules
  }

  menusUpdate = (menus: Menu[]) => {
    this.menus = menus
  }

  entityUpdate = (entity: string | undefined) => {
    this.entity = entity
  }

  update = (
    entity: string | undefined,
    module: Module | undefined,
    menu: Menu | undefined,
    menuSub: Menu | undefined
  ) => {
    this.entity = entity
    this.module = module
    this.menuParent = menu
    this.menuSub = menuSub
  }

  updateWarehouses = (warehouses: Relation[]) => {
    this.warehouses = warehouses
  }

  updateWarehouseSelect = (warehouse: Relation) => {
    this.warehouse_select = warehouse
  }

}

export const appStore = new AppStore()
